<template>
    <!-- 04 : 教育合作伙伴 -->
    <div class="solution-edu-part-4">
        <div class="solution-edu-part-4-description">
            {{ $t(data.part_4_des) }}
        </div>
        <div class="solution-edu-part-4-container">
            <div class="solution-edu-part-4-right">
                <div class="solution-edu-part-4-logos education-slide-in-up">
                    <picture>
                        <source
                            media="(max-width: 750px)"
                            :srcset="isCN ? collegeLogoImgMobile : collegeLogoImgMobileEn"
                        />
                        <img :data-src="isCN ? collegeLogoImg : collegeLogoImgEn" class="lazy" alt="" />
                    </picture>
                </div>
                <!-- <CommonComponentsButtonLine :button-text="t('global_link_button_0')" /> -->
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
    import part4character from '@assets/imgs/Solutions/Education/part4character.png';
    import collegeLogoImg from '@assets/imgs/Solutions/Education/collegeLogos.png';
    import collegeLogoImgEn from '@assets/imgs/Solutions/Education/collegeLogosEn.png';
    import collegeLogoImgMobile from '@assets/imgs/Solutions/Education/collegeLogosMobile.png';
    import collegeLogoImgMobileEn from '@assets/imgs/Solutions/Education/collegeLogosMobileEn.png';

    import { ifCNLocale } from '~~/composables/useLocale.ts';
    import i18n from '@/locales';
    const isCN = ifCNLocale();
    const { t } = i18n.global;

    const data = {
        part_4_Character: part4character,
        part_4_des: 'global_solutions_edu_part_4_description',
    };
</script>

<style lang="less" scoped>
    .solution-edu-part-4 {
        margin: 156px 0 131px 0;

        &-container {
            width: 100%;
            background: #ffffff;
            border-radius: .convert(40px) [ @vw];

            padding: .convert(45px) [ @vw] .convert(47px) [ @vw];
            display: flex;
            justify-content: center;
            align-items: center;

            .solution-edu-part-4-right {
                width: 100%;
                img {
                    width: 100%;
                }

                // .solution-edu-part-4-logos {
                // }
            }

            @media (max-width: @screen-mobile-width) {
                display: block;
                height: fit-content;
                width: 100%;
                padding: 25px 31px;
                .solution-edu-part-4-character {
                    display: none;
                }
            }
        }

        &-description {
            text-align: center;
            color: #ffffff;
            font-size: .convert(@font-size-title) [ @vw];
            color: #fff;
            line-height: normal;
            margin-bottom: .convert(30px) [ @vw];

            @media (max-width: @screen-mobile-width) {
                font-size: 16px;
                margin-bottom: 15px;
            }
        }

        @media (max-width: @screen-mobile-width) {
            margin: 40px 0 46px 0;
        }
    }

    :lang(en) {
        .solution-edu-part-4 {
            &-container {
                height: auto;
                display: flex;
                justify-content: center;
                align-items: center;

                padding: .convert(73px) [ @vw];
            }
            &-description {
                font-size: .convert(36px) [ @vw];
            }
        }
    }
</style>
